import { render, staticRenderFns } from "./CourseContentBlock.vue?vue&type=template&id=2f16c584&"
import script from "./CourseContentBlock.vue?vue&type=script&lang=js&"
export * from "./CourseContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports